import cx from 'classnames';
import React, { useState } from 'react';
import {
  BrowserRouter as Router, Route, Switch, useParams
} from "react-router-dom";
import { Application, Navbar, Sidebar, Spacer } from '../../components';

export default function AppList() {
  return (
    <Router forceRefresh={true}>
      <Switch>
        <Route path='/applist/:id' children={<Child />} />
      </Switch>
    </Router>
  )
}

function Child() {
  const [closeSide, setCloseSide] = useState(false);
  const toggleMenu = () => {
    if (closeSide) {
      setCloseSide(false)
    } else {
      setCloseSide(true)
    }
  }
  const classContentWrapper = cx({
    'scrollCustom': true,
    'contentWrapper': true,
    'wide': closeSide
  })

  let { id } = useParams();
  return (
    <div className="page">
      <Navbar onClick={toggleMenu} closeSide={closeSide} />
      <div className="mainWrapper">
        <Sidebar closeSide={closeSide} />
        <div className={classContentWrapper}>
          <div className="container-fluid">
            <Spacer h={20} />
              <Application id={id} />
          </div>
        </div>
      </div>
    </div>
  );
}
